<template>
<el-dialog :close-on-click-modal="false" width="80%" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog" append-to-body>
    <div class="h-rowIn" >
        <div class="h-rowBox">
            <el-row :gutter="20">
                <el-col :span="12">
                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                        <h1>产品信息</h1>
                    </div>
                    <el-table
                            @selection-change="handleSelectionChange1"
                            ref="table1"
							:border="true"
                            max-height="450"
                            :data="proProductwx"
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="50"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="productId"
                                label="产品编码"
                                min-width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="productName"
                                label="产品型号"
                                min-width="150"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="xuniFlag"
                                label="产品类型">
                            <template scope="scope">
                                {{scope.row.xuniFlag|dictname('xuni_flag')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="productDes"
                                label="产品描述"
                                min-width="150"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                    </el-table>
                </el-col>

                <el-col :span="12">
                    <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;">
                        <h1>供应商信息</h1>
                    </div>
                    <div class="h-formBox" style="margin-bottom: -10.9px">
                        <el-form :inline="true" :model="gysquery" class="demo-form-inline h-formBorder">
                            <el-form-item label="供应商编码/名称">
                                <el-input clearable v-model="gysquery.codeNameLike"></el-input>
                            </el-form-item>
                            <el-form-item class="h-formBtnOut">
                                <el-button type="primary" @click="gysqueryPage">搜索</el-button>
                                <el-button type="primary" @click="selectAll">全选</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <el-table
                            @selection-change="handleSelectionChange2"
                            ref="table2"
                            max-height="450"
							:border="true"
                            :data="optionsSupplier"
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="50"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="usercode"
                                min-width="90"
                                label="供应商编码">
                        </el-table-column>
                        <el-table-column
                                prop="userName"
                                label="供应商名称"
                                min-width="150"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                    </el-table>
                    <paginationminNosize :page="gysquery" @query="gysqueryPage" style="padding-top: 0.1rem"/>
                </el-col>
            </el-row>
            <el-row :gutter="20" style="border-top: 3px solid #ccc;padding-top: 5px;">
                <el-col :span="12" >
                    <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;">
                        <h1>已选产品</h1>
                    </div>
                    <ul style="max-height:200px;overflow-y: auto">
                        <li v-for="(item,i)  in this.list1">
                            {{item.productId}} {{item.productName}} <a href="javascript:;" style="color:red;" @click.stop="deletelist1(item.productName)">×</a>
                        </li>
                    </ul>
                </el-col>

                <el-col :span="12">
                    <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;">
                        <h1>已选供应商</h1>
                    </div>
                    <ul style="max-height:200px;overflow-y: auto">
                        <li v-for="(item,i)  in this.list2">
                            {{item.usercode}} {{item.userName}} <a href="javascript:;" style="color:red;"  @click.stop="deletelist2(item.usercode)">×</a>
                        </li>
                    </ul>
                </el-col>
            </el-row>
            <el-row>
                <div style="text-align: center;">
                    <el-button type="primary"  @click="addoneXunjiazu">发起询价</el-button>
                </div>
            </el-row>
        </div>
    </div>
</el-dialog>
</template>

<script>
    import ss from '../../api/SystemService'
    export default {
        data(){
          return {
              gysquery:{
                  pageSize:8,
                  pageNo:1,
                  total:0,
                  codeNameLike:null,
              },
              proProductwx:[],
              optionsSupplier:[],
              list1:[],
              list2:[],

              allflag:false,
          }
        },
        created(){
            this.queryChanpList();
            this.gysqueryPage()
        },
        methods: {
            //项目下的产品
            queryChanpList() {
                ss.Product.getProductInfoByProjectId(this.xmid).then(rd => {
                    console.log("产品信息：",rd)
                    this.proProductwx=rd;
                });
            },
            //供应商信息
            gysqueryPage() {
                ss.ProService.selectCaiGouListPage(this.gysquery).then(rd => {
                    console.log("项目信息",rd);
                    this.gysquery.total = rd.total;
                    this.optionsSupplier = rd.records;
                })
            },
            selectAll(){
                if(this.gysquery.total>2000){
                    this.$msg.msge("一次性添加2000个以上供应商询价，请联系管理员处理！")
                    return;
                }
                this.list2 = [];
                this.list2.push({
                    usercode:'All',
                    userName:"所有供应商用户"
                });
            },
            addoneXunjiazu(){
                console.log(this.list1)
                console.log(this.list2)
                this.$emit('addoneXunjiazu', this.list1,this.list2)

            },
            handleSelectionChange1(v){
                this.list1=v;
            },
            handleSelectionChange2(v){
                if(_.find(this.list2,{"usercode":"All"})){
                    this.$refs.table2.clearSelection();
                    this.$msg.msge("已经选择全部用户，不用重复勾选！")
                    return;
                }
                v.forEach(row=>{
                    if(!_.find(this.list2,{"usercode":row.usercode})){
                        this.list2.push(row);
                    }
                })
                // var notsel = _.filter(this.optionsSupplier,(o)=>{
                //     return !_.includes(v,{"usercode":o.usercode})
                // })
                // console.log(notsel);
                //
                // this.list2.forEach(row=>{
                //     if(_.find(notsel,{"usercode":row.usercode})){
                //         this.list2 = _.reject(this.list2, {'usercode': row.usercode});
                //     }
                // })

            },
            deletelist1(v){
                console.log(v)
                var delrow = _.find(this.list1, {'productName': v});
                if(delrow){
                    this.$refs.table1.toggleRowSelection(delrow);
                }
                this.list1 = _.reject(this.list1, {'productName': v});
            },
            deletelist2(v){
                console.log(v)
                var delrow = _.find(this.list2, {'usercode': v});
                this.list2 = _.reject(this.list2, {'usercode': v});
                // if(delrow && _.find(this.optionsSupplier, {'usercode': v})) {
                //     this.$refs.table2.toggleRowSelection(delrow);
                // }

            },
        },
        props: {
            xmid: {
                type: String,
            },
        }
    }
</script>

<style>
    .xuanzewuliao .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .xuanzewuliao .el-dialog__body{
        padding: 20px;
    }
    .xuanzewuliao .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .xuanzewuliao .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .xuanzewuliao  .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline{
        padding-top: 0;
    }
    .xuanzewuliao .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .xuanzewuliao .h-rowCon{
        padding-bottom: 0rem;
    }
</style>
